import { FC } from "react";
import { PerformanceAxisTickProps } from "./types";

export const CustomXTick: FC<React.PropsWithChildren<PerformanceAxisTickProps>> = (props: PerformanceAxisTickProps) => {
    const { x, y, payload } = props;
    
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dx={-4} dy={16} textAnchor="end" fill="#333" transform="rotate(-40)">
                {payload.value.toLocaleString()}
            </text>
        </g>
    );
}